import { encode } from 'uqr';

/**
 * QR code en SVG (modules noirs sur fond blanc, marge de 4 modules exigée par
 * la norme) : lu par l'application d'authentification sur l'écran.
 */
export function QrCode({ valeur, taille = 184, libelle }: { valeur: string; taille?: number; libelle: string }) {
  const { data, size } = encode(valeur, { ecc: 'M', border: 4 });
  let chemin = '';
  data.forEach((ligne, y) =>
    ligne.forEach((noir, x) => {
      if (noir) chemin += `M${x},${y}h1v1h-1z`;
    })
  );
  return (
    <svg className="qr" width={taille} height={taille} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={libelle} shapeRendering="crispEdges">
      <rect width={size} height={size} fill="#fff" />
      <path d={chemin} fill="#000" />
    </svg>
  );
}
